/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmListDocumentExecutionsSortCriteria {
    getFixupPrototypeFunction() { return AwsSsmListDocumentExecutionsSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmListDocumentExecutionsSortCriteria>): AwsSsmListDocumentExecutionsSortCriteria {
        let obj = Object.assign(new AwsSsmListDocumentExecutionsSortCriteria(), model);
        AwsSsmListDocumentExecutionsSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmListDocumentExecutionsSortCriteria>): AwsSsmListDocumentExecutionsSortCriteria {
        if (!model) return null;
        return AwsSsmListDocumentExecutionsSortCriteria.newInstance(<AwsSsmListDocumentExecutionsSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmListDocumentExecutionsSortCriteria) {
        if (!obj) return;

        models.AwsSsmListDocumentExecutionsSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmListDocumentExecutionsSortCriteria): boolean {
        Object.setPrototypeOf(obj, AwsSsmListDocumentExecutionsSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.AwsSsmListDocumentExecutionsSortColumn;

    ascending: boolean;

}
